module.exports = __webpack_public_path__ + "img/product-5-INTAGP.44ff5980.png";